(function () {
  'use strict';

  // Deux formes de tri/filtre partagent ce fichier :
  //
  //   [data-facets]         le thème Shopify. Le filtrage est fait par Shopify côté
  //                         serveur (paramètres filter.p.*), on se contente d'envoyer
  //                         le formulaire dès qu'une case change au lieu d'attendre
  //                         un clic sur « Appliquer ».
  //
  //   [data-facets-client]  la vitrine du prototype, qui n'a pas de serveur : on filtre,
  //                         trie et pagine les cartes déjà présentes dans le DOM.
  //
  // Dans les deux cas le formulaire reste utilisable sans JS (envoi GET classique).

  function debounce(fn, wait) {
    var timer = null;
    return function () {
      var args = arguments;
      var self = this;
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        fn.apply(self, args);
      }, wait);
    };
  }

  /* ---------------------------------------------------------------- thème */

  function enhanceServerFacets(form) {
    form.classList.add('facets--live');

    var submit = form.querySelector('[data-facets-submit]');
    // Le bouton n'est masqué qu'une fois l'auto-envoi réellement branché : sans JS
    // il reste le seul moyen d'appliquer les filtres.
    if (submit) submit.hidden = true;

    var send = function () {
      if (form.requestSubmit) {
        form.requestSubmit();
      } else {
        form.submit();
      }
    };
    var sendSoon = debounce(send, 500);

    form.addEventListener('change', function (event) {
      if (event.target.type === 'number') return;
      send();
    });

    form.addEventListener('input', function (event) {
      if (event.target.type !== 'number') return;
      sendSoon();
    });
  }

  /* ------------------------------------------------------------ prototype */

  function ClientFacets(form) {
    this.form = form;
    this.grid = document.querySelector(form.dataset.facetsClient);
    if (!this.grid) return;

    this.cards = Array.prototype.slice.call(this.grid.children);
    this.count = document.querySelector('[data-facet-count]');
    this.empty = document.querySelector('[data-facet-empty]');
    this.chips = document.querySelector('[data-facet-active]');
    this.pagination = document.querySelector('[data-facet-pagination]');
    this.perPage = Number(form.dataset.perPage) || this.cards.length;
    this.page = 1;

    this.groups = {};
    var self = this;
    Array.prototype.forEach.call(form.querySelectorAll('input[type="checkbox"][name]'), function (input) {
      if (!self.groups[input.name]) self.groups[input.name] = [];
      self.groups[input.name].push(input);
    });

    this.sort = form.querySelector('select[name="sort"]');

    // Les filtres s'appliquent au clic : « Appliquer » ne sert plus qu'au cas sans JS,
    // ou il reste le seul declencheur. Meme geste que sur le theme.
    var submit = form.querySelector('[data-facets-submit]');
    if (submit) submit.hidden = true;
    form.classList.add('facets--live');

    this.readUrl();
    this.bind();
    this.apply(false);
  }

  ClientFacets.prototype.key = function (name) {
    return 'facet' + name.charAt(0).toUpperCase() + name.slice(1);
  };

  ClientFacets.prototype.bind = function () {
    var self = this;

    this.form.addEventListener('change', function () {
      self.page = 1;
      self.apply(true);
    });

    this.form.addEventListener('submit', function (event) {
      event.preventDefault();
      self.page = 1;
      self.apply(true);
    });

    this.form.addEventListener('click', function (event) {
      if (!event.target.closest('[data-facets-clear]')) return;
      event.preventDefault();
      self.reset();
    });

    if (this.chips) {
      this.chips.addEventListener('click', function (event) {
        var chip = event.target.closest('[data-facet-remove]');
        if (!chip) return;
        var input = self.form.querySelector(
          'input[name="' + chip.dataset.group + '"][value="' + chip.dataset.facetRemove + '"]'
        );
        if (input) input.checked = false;
        self.page = 1;
        self.apply(true);
      });
    }

    if (this.pagination) {
      this.pagination.addEventListener('click', function (event) {
        var link = event.target.closest('[data-facet-page]');
        if (!link) return;
        event.preventDefault();
        self.page = Number(link.dataset.facetPage);
        self.apply(true);
        var main = document.querySelector('.collection__main');
        if (main) main.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    window.addEventListener('popstate', function () {
      self.readUrl();
      self.apply(false);
    });
  };

  // Les liens de la page « Les maisons » arrivent avec ?maison=Crezus : on pré-coche la
  // case correspondante pour que la vitrine s'ouvre déjà filtrée sur cette maison.
  ClientFacets.prototype.readUrl = function () {
    var params = new URLSearchParams(window.location.search);
    var self = this;

    Object.keys(this.groups).forEach(function (name) {
      var wanted = params.getAll(name);
      self.groups[name].forEach(function (input) {
        input.checked = wanted.indexOf(input.value) !== -1;
      });
    });

    if (this.sort && params.get('sort')) this.sort.value = params.get('sort');
    this.page = Math.max(1, Number(params.get('page')) || 1);
  };

  ClientFacets.prototype.writeUrl = function () {
    var params = new URLSearchParams();
    var self = this;

    Object.keys(this.groups).forEach(function (name) {
      self.groups[name].forEach(function (input) {
        if (input.checked) params.append(name, input.value);
      });
    });

    if (this.sort && this.sort.value !== this.sort.options[0].value) {
      params.set('sort', this.sort.value);
    }
    if (this.page > 1) params.set('page', String(this.page));

    var query = params.toString();
    window.history.replaceState({}, '', window.location.pathname + (query ? '?' + query : ''));
  };

  ClientFacets.prototype.selection = function () {
    var picked = {};
    var self = this;
    Object.keys(this.groups).forEach(function (name) {
      var values = self.groups[name]
        .filter(function (input) { return input.checked; })
        .map(function (input) { return input.value; });
      if (values.length) picked[name] = values;
    });
    return picked;
  };

  // Dans un groupe les valeurs s'additionnent (OU), entre groupes elles se croisent (ET) :
  // « Crezus ou Sigal » ET « Colliers ». C'est la convention de Shopify.
  ClientFacets.prototype.matches = function (card, picked, skipGroup) {
    var self = this;
    return Object.keys(picked).every(function (name) {
      if (name === skipGroup) return true;
      var owned = (card.dataset[self.key(name)] || '').split('|');
      return picked[name].some(function (wanted) { return owned.indexOf(wanted) !== -1; });
    });
  };

  ClientFacets.prototype.order = function (cards) {
    var mode = this.sort ? this.sort.value : 'nouveaute';
    var by = {
      'prix-asc': function (a, b) { return Number(a.dataset.price) - Number(b.dataset.price); },
      'prix-desc': function (a, b) { return Number(b.dataset.price) - Number(a.dataset.price); },
      alpha: function (a, b) { return a.dataset.name.localeCompare(b.dataset.name, 'fr'); },
      nouveaute: function (a, b) { return Number(a.dataset.new) - Number(b.dataset.new); }
    };
    return cards.slice().sort(by[mode] || by.nouveaute);
  };

  ClientFacets.prototype.apply = function (push) {
    var picked = this.selection();
    var self = this;

    var kept = this.order(
      this.cards.filter(function (card) {
        return self.matches(card, picked, null);
      })
    );

    var pages = Math.max(1, Math.ceil(kept.length / this.perPage));
    if (this.page > pages) this.page = pages;
    var from = (this.page - 1) * this.perPage;
    var shown = kept.slice(from, from + this.perPage);

    // On réordonne les nœuds eux-mêmes plutôt que de tricher avec l'ordre visuel CSS :
    // l'ordre du DOM est celui que suivent la tabulation et les lecteurs d'écran.
    var fragment = document.createDocumentFragment();
    shown.forEach(function (card) {
      card.hidden = false;
      fragment.appendChild(card);
    });
    this.cards.forEach(function (card) {
      if (shown.indexOf(card) === -1) {
        card.hidden = true;
        fragment.appendChild(card);
      }
    });
    this.grid.appendChild(fragment);

    this.refreshCounts(picked);
    this.refreshChips(picked);
    this.refreshCount(kept.length);
    this.refreshPagination(pages);

    if (this.empty) this.empty.hidden = kept.length > 0;
    if (push) this.writeUrl();
  };

  // Un compteur annonce ce qui resterait si on cochait cette valeur, compte tenu des
  // AUTRES groupes déjà cochés. Sans ça on propose des filtres qui ne renvoient rien.
  ClientFacets.prototype.refreshCounts = function (picked) {
    var self = this;

    Object.keys(this.groups).forEach(function (name) {
      var pool = self.cards.filter(function (card) {
        return self.matches(card, picked, name);
      });
      var key = self.key(name);

      self.groups[name].forEach(function (input) {
        var total = pool.filter(function (card) {
          return (card.dataset[key] || '').split('|').indexOf(input.value) !== -1;
        }).length;

        var label = input.closest('.facet__label');
        var slot = label ? label.querySelector('.facet__count') : null;
        if (slot) slot.textContent = total;

        input.disabled = total === 0 && !input.checked;
        var item = input.closest('.facet__item');
        if (item) item.classList.toggle('facet__item--empty', input.disabled);
      });

      var group = self.groups[name][0].closest('.facet');
      if (!group) return;
      var active = self.groups[name].filter(function (input) { return input.checked; }).length;
      group.classList.toggle('facet--active', active > 0);
      var dot = group.querySelector('.facet__dot');
      if (dot) dot.hidden = active === 0;
      if (active > 0) group.open = true;
    });
  };

  ClientFacets.prototype.refreshChips = function (picked) {
    if (!this.chips) return;
    var names = Object.keys(picked);

    // Construit en DOM plutôt qu'en innerHTML : ces libellés viennent du catalogue du
    // client, ils ne doivent jamais être concaténés dans une chaîne de HTML.
    var host = this.chips;
    host.textContent = '';

    names.forEach(function (name) {
      picked[name].forEach(function (value) {
        var button = document.createElement('button');
        button.className = 'facet-chip label-condensed';
        button.type = 'button';
        button.dataset.group = name;
        button.dataset.facetRemove = value;
        button.appendChild(document.createTextNode(value));

        var cross = document.createElement('span');
        cross.className = 'facet-chip__cross';
        cross.setAttribute('aria-hidden', 'true');
        cross.textContent = '×';
        button.appendChild(cross);

        var hint = document.createElement('span');
        hint.className = 'visually-hidden';
        hint.textContent = '— retirer ce filtre';
        button.appendChild(hint);

        var item = document.createElement('li');
        item.appendChild(button);
        host.appendChild(item);
      });
    });

    this.chips.hidden = names.length === 0;
  };

  ClientFacets.prototype.refreshCount = function (total) {
    if (!this.count) return;
    if (total === 0) {
      this.count.textContent = 'Aucune pièce';
    } else {
      this.count.textContent = total + (total > 1 ? ' pièces' : ' pièce');
    }
  };

  // L'URL d'une page donnée, filtres et tri compris : un point de pagination reste
  // un vrai lien (ouverture dans un onglet, clic milieu, rechargement) et pas un « # ».
  ClientFacets.prototype.pageUrl = function (page) {
    var params = new URLSearchParams(window.location.search);
    if (page > 1) {
      params.set('page', String(page));
    } else {
      params.delete('page');
    }
    var query = params.toString();
    return window.location.pathname + (query ? '?' + query : '');
  };

  ClientFacets.prototype.refreshPagination = function (pages) {
    if (!this.pagination) return;

    this.pagination.hidden = pages < 2;
    this.pagination.textContent = '';
    if (pages < 2) return;

    var list = document.createElement('ul');
    list.className = 'pagination__list';

    for (var i = 1; i <= pages; i += 1) {
      var current = i === this.page;
      var link = document.createElement(current ? 'span' : 'a');
      link.className = 'pagination__link' + (current ? ' pagination__link--current' : '');
      if (current) {
        link.setAttribute('aria-current', 'page');
      } else {
        link.href = this.pageUrl(i);
        link.dataset.facetPage = String(i);
      }

      var label = document.createElement('span');
      label.className = 'visually-hidden';
      label.textContent = 'Page ' + i;
      link.appendChild(label);

      var mark = document.createElement('span');
      mark.className = 'pagination__mark';
      mark.setAttribute('aria-hidden', 'true');
      link.appendChild(mark);

      var item = document.createElement('li');
      item.appendChild(link);
      list.appendChild(item);
    }

    this.pagination.appendChild(list);
  };

  ClientFacets.prototype.reset = function () {
    var self = this;
    Object.keys(this.groups).forEach(function (name) {
      self.groups[name].forEach(function (input) { input.checked = false; });
    });
    if (this.sort) this.sort.value = this.sort.options[0].value;
    this.page = 1;
    this.apply(true);
  };

  function init() {
    document.querySelectorAll('form[data-facets-client]').forEach(function (form) {
      if (form.dataset.facetsBound === 'true') return;
      form.dataset.facetsBound = 'true';
      new ClientFacets(form);
    });
    document.querySelectorAll('form[data-facets]:not([data-facets-client])').forEach(function (form) {
      if (form.dataset.facetsBound === 'true') return;
      form.dataset.facetsBound = 'true';
      enhanceServerFacets(form);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Rechargement d'une section par l'editeur de theme : le formulaire de facettes est
  // un noeud neuf, il faut le rebrancher. Le drapeau data-facets-bound evite de
  // brancher deux fois le meme.
  document.addEventListener('shopify:section:load', init);
})();
